<template>
  <Loader :isLoading="loading">
    <div class="row justify-content-between">
      <div :class="(showDetails && mailData && mailData.id) ? 'col-5' : 'col-12'">
        <Card title="projects.historics" titleClass="fw-bolder fs-2">
          <template #cardBody>
            <div class="scroll-y" style="max-height: 518px;" v-if="mails?.length">
              <div v-for="(mail, index) in mails" :key="index">
                <MailHistoryItem :id="index" :mail="mail" :active="mail?.id === mailData?.id" @click="detailData(mail)"/>
              </div>
            </div>
            <div class="text-center" v-else>
              <Img filename="empty.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
            </div>
          </template>
        </Card>
      </div>
      <Transition name="fade">
          <div v-if="showDetails && mailData && mailData.id" class="col-7 d-flex">
              <div class="vertical-line"></div>   
              <Card  class="card p-5 h-100 w-100"> 
                <template #cardHeader>
                    <div class="card-header px-5">
                        <h3 class="card-title align-items-start flex-column">
                          {{ $t('mail.overview') }}
                        </h3>
                        <div class="card-toolbar">
                            <i @click.prevent="closeDetail" class="fas fa-times fs-3  mr-15"></i>
                        </div>
                    </div>
                </template>
                <div class="my-4 ">
                    <MailHistoryDetail :large="true" :schedule="true" :detailItem="mailData" />
                </div>
              </Card>

          </div>
      </Transition> 
    </div>
  </Loader>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import Card from "@/components/Card"
  import Img from "@/components/Img.vue";
import MailHistoryItem from "./MailHistoryItem.vue";
import MailHistoryDetail from "./MailHistoryDetail";
import Loader from "@/components/Loader.vue";

const store = useStore()
const route = useRoute()

const mails = ref([]) 
const mailData = ref({}) 
const loading = ref(true) 
const showDetails = ref(false) 

onMounted(() => {
  store.dispatch('mails/loadHistoryMails', {model_type:  'Core\\v1\\Project\\Models\\Project', model_id:route.params.id}).then((response) => {
    if(response.data.data) {
      mails.value = response.data.data
    }
  }).finally(() => {
    loading.value = false
  })
})

function detailData(mail){
  showDetails.value = true
  mailData.value = mail
}

function closeDetail(){
  showDetails.value = false
  mailData.value = {}
}


</script>